import React, { useEffect } from "react";
import AOS from "aos";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Preloader from "../components/sections/Preloader";
import Banner from "../components/sections/Banner";
import AboutSection from "../components/sections/AboutSection";
// import Speciality from "../components/sections/Speciality";
// import Portfolio from "../components/sections/Portfolio";
import Project from "../components/sections/Project";
// import Roadmap from "../components/sections/Roadmap";
import Team from "../components/sections/Team";
// import Benefits from "../components/sections/Benefits";
import ScrollTop from "../components/sections/ScrollTop";
import "../styles/home.css";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      delay: 0,
      easing: 'ease-out-cubic',
      disable: false,
      startEvent: 'DOMContentLoaded',
      animatedClassName: 'aos-animate',
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,
    });
    
    // Refresh AOS on scroll for better performance
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          AOS.refresh();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="body header-fixed home-main">
      <div className="wrapper">
        <Preloader />
        <Menu />
        <section id="banner">
          <Banner />
        </section>
        <section id="about">
          <AboutSection />
        </section>
        {/* <section id="speciality">
          <Speciality />
        </section>
        <section id="portfolio">
          <Portfolio />
        </section> */}
        <section id="project">
          <Project />
        </section>
        {/* <section id="roadmap">
          <Roadmap />
        </section> */}
        <section id="team">
          <Team />
        </section>
        <section id="footer">
          <Footer />
        </section>
        <ScrollTop />
      </div>
    </div>
  );
};

export default Home;
